import * as CommonActions from './common';
import * as InternalOrderActions from './internalOrder';
import * as VerifyInvoiceActions from './verifyInvoice';
import * as VerifyBoxActions from './verifyBox';
import * as CheckingActions from './checking';
import * as StorageActions from './storage';
import * as CloseActions from './close';
import * as InvoicingActions from './invoicing';
import * as LabelsReprintActions from './labelsReprint';

const Actions = {
  ...CommonActions,
  ...InternalOrderActions,
  ...VerifyInvoiceActions,
  ...LabelsReprintActions,
  ...InvoicingActions,
  ...VerifyBoxActions,
  ...CheckingActions,
  ...StorageActions,
  ...CloseActions,
};

export default Actions;
